
/**
* cardsList.directives Module
*
* Description
*/
var app = angular.module('directives.cardsList', []);

	require('./directives/cards.directive.js');
	require('./stylesheet/style.scss');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardsList/index.js
 ** module id = 146
 ** module chunks = 1
 **/